import { render, staticRenderFns } from "./GridFreeZone.vue?vue&type=template&id=3d5878a8&scoped=true&"
import script from "./GridFreeZone.vue?vue&type=script&lang=ts&"
export * from "./GridFreeZone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5878a8",
  null
  
)

export default component.exports